module.exports = __webpack_public_path__ + "2fb1f149dbd52448aebf37b6495c219b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/familyActivities/Assets/6_ways_to_have_fun_with_vegetables.png
// module id = 1358
// module chunks = 0